<template>
    <el-date-picker
        v-model="range"
        type="daterange"
        range-separator="Hasta"
        start-placeholder="Fecha Inicial"
        end-placeholder="Fecha Final"
    >
    </el-date-picker>
</template>

<script>
export default {
    data() {
        return {
            range: "",
        };
    },
    watch: {
        range(range) {
            this.$emit("change", range);
        },
    },
};
</script>
